import { useParams } from 'react-router-dom';
import { useContext, useState, useEffect } from 'react';
import Question from './question';
import { StepsContext } from '../context/StepsContext';
import NextPreviousParse from './nextPreviousParse';

const currentQuestion = (): JSX.Element => {
  const qContext = useContext(StepsContext);
  const urlParams = useParams();
  const [valid, setValid] = useState(false);
  const currentQuestionId = urlParams.currentID ? parseInt(urlParams.currentID, 10) : 0;
  const [currentAnswer, setCurrentAnswer] = useState<Array<string>>([]);

  const currentStep = qContext.steps?.stepsArray.find((step) => {
    return step.questionList.some((question) => {
      if (question.id === currentQuestionId) {
        qContext.steps?.setCurrentIndex(qContext.steps?.stepsArray.indexOf(step));
        qContext.currentStep = qContext.steps?.stepsArray[qContext.steps?.currentIndexValue];
      }
      return question.id === currentQuestionId;
    });
  });

  const validHandler = (): void => {
    let validFail = 0;
    if (qContext.currentStep && qContext.currentStep.questionList[0].fieldType !== 'slider') {
      for (const i of qContext.currentStep.questionList) {
        if (qContext.answers[i.id]?.answer.length === 0) {
          validFail += 1;
        }
      }
    }
    if (validFail > 0) {
      setValid(false);
    } else {
      setValid(true);
    }
  };

  const completedStepsHandler = (): void => {
    if (qContext.steps?.currentIndexValue! > 0) {
      let prevStepIndex = qContext.completedSteps.indexOf(
        qContext.previousStep?.questionList[0].id!,
      );
      qContext.completedSteps.splice(
        prevStepIndex + 1,
        0,
        qContext.currentStep?.questionList[0].id!,
      );
    } else {
      qContext.completedSteps.push(qContext.currentStep?.questionList[0].id!);
    }
  };

  const onSelectionHandler = (
    questionId: number,
    value: Array<string>,
    drug: Array<string>,
  ): void => {
    qContext.answers[questionId] = { drugs: drug, answer: value };
    validHandler();
    setCurrentAnswer(value);
  };

  useEffect(() => {
    validHandler();
    if (qContext.completedSteps.indexOf(qContext.currentStep?.questionList[0].id!) === -1) {
      completedStepsHandler();
    }
  }, [qContext.currentStep]);

  return (
    <div className="question-container">
      {currentStep?.questionList.map((quest) => (
        <div key={quest.id}>
          <Question questionData={quest} onSelection={onSelectionHandler} />
        </div>
      ))}
      <NextPreviousParse valid={valid} value={currentAnswer} />
    </div>
  );
};
export default currentQuestion;
